import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { Toaster } from "./ui/sonner"

const Layout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
      <Toaster />
    </div>
  );
};

export default Layout;
